// extracted by mini-css-extract-plugin
export var hidden = "_tb-0";